import { first } from 'rxjs/operators';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../services'

@Component({
    styles: [`
        .error-block {
            display: inline-block;
            position: relative;
        }
    `],
    template: `
        <h2 mat-dialog-title>Sign-up</h2>
        <mat-dialog-content fxLayout="column">
            <h4>Sign-up with your email address. We will send you a link to create your account.</h4>
            <mat-form-field>
                <input matInput
                       type="text"
                       placeholder="Email"
                       name="emailAddressCtrl"
                       [(ngModel)]="emailAddress"
                       #emailAddressCtrl="ngModel"
                       required 
                       [pattern]="emailPattern">
                <mat-error *ngIf="emailAddressCtrl.hasError('required')">Email Address cannot be blank.</mat-error>                
                <mat-error *ngIf="emailAddressCtrl.hasError('pattern')">Email Address must be valid.</mat-error>                
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-raised-button color="primary" (click)="startSignup()">Next</button>
            <button mat-button (click)="cancel()">Cancel</button>
        </mat-dialog-actions>
    `
})
export class StartSignupComponent {
    readonly emailPattern = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    emailAddress: string;

    constructor(private dialogRef: MatDialogRef<StartSignupComponent>,
                public snackBar: MatSnackBar,
                private userService: UserService){}

    cancel = () => this.dialogRef.close();

    startSignup = () => this.userService.startSignup({ emailAddress: this.emailAddress }).pipe(first())
    .subscribe(() => {
        this.snackBar.open('We sent a signup email! Please check your email to finish the signup process.', 'OK', { duration: 3000});
        this.dialogRef.close();
    });
}
